import styled from 'astroturf/react'
import _Fieldset from "Fieldset.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/form/fieldset.js?styleId=Fieldset";


const Fieldset = /*#__PURE__*/styled('fieldset', null, {
  displayName: "Fieldset",
  styles: _Fieldset
})

export default Fieldset
